import React from "react";

const AdminFooter = () => {
    return (
        <footer id="footer" className="footer">
        <div className="credits">
          Website Content Owned & Managed by Department of Agriculture & Farmers Welfare | MoA&FW | Government of India, India<br/>
          Designed and Developed by <a href="#">DAD/IT, Ministry of Agriculture, New Delhi, India.</a>
        </div>
      </footer>
    )

}

export default AdminFooter